export default __webpack_public_path__ + "static/media/logo.92a76827.svg";